// import gsap from 'gsap'      
import { gsap } from "gsap";




let text1 = document.querySelector('.text_1')
let text2 = document.querySelector('.text_2')
let text3 = document.querySelector('.text_3')
let text4 = document.querySelector('.text_4')
const imageContainer1 = document.querySelector('.temp_display1')
const imageContainer2 = document.querySelector('.temp_display2')
const imageContainer3 = document.querySelector('.temp_display3')
const imageContainer4 = document.querySelector('.temp_display4')
const tagContainer =  document.querySelector('.img_tag')
const tag1 = document.querySelectorAll('.tags_1')
const tag2 = document.querySelectorAll('.tags_2')
const tag3 = document.querySelectorAll('.tags_3')
const tag4 = document.querySelectorAll('.tags_4')

// timeline animation setup
const tl = gsap.timeline({paused:true})
const tl1 = gsap.timeline({paused: true})

const tlt = gsap.timeline({paused:true})
const tl2 = gsap.timeline({paused: true})

const tlk = gsap.timeline({paused:true})
const tl3 = gsap.timeline({paused: true})

const tlj = gsap.timeline({paused:true})
const tl4 = gsap.timeline({paused: true})


// first animation
text1.addEventListener('mouseenter', ()=>{
    tl1.play()
    tl1.delay(0.2).restart(true)
    tl.play().delay(1).restart(true)
})   

text1.addEventListener('mouseleave', ()=>{
    tl1.reverse()
    tl.reverse()
})

// second animation
text2.addEventListener('mouseenter', ()=>{
    tl2.play()
    tl2.delay(0.2).restart(true)
    tlt.play().delay(1).restart(true)
})   

text2.addEventListener('mouseleave', ()=>{
    tl2.reverse()
    tlt.reverse()
})

// third animation
text3.addEventListener('mouseenter', ()=>{
    tl3.play()
    tl3.delay(0.2).restart(true)
    tlk.play().delay(1).restart(true)
})   

text3.addEventListener('mouseleave', ()=>{
    tl3.reverse()
    tlk.reverse()
})

// fourth animation
text4.addEventListener('mouseenter', ()=>{
    tl4.play()
    tl4.delay(0.2).restart(true)
    tlj.play().delay(1).restart(true)
})   

text4.addEventListener('mouseleave', ()=>{
    tl4.reverse()
    tl4.reverse()
})




// the div animation
tl1.from('.temp_display1', {
    x:100,
    y:100,
    opacity:0,
    rotation: -10,
    duration:1,
    ease: 'Expo.easeOut',
    transformOrigin: 'top center',
    skewX: -10,
})
tl2.from('.temp_display2', {
    x:100,
    y:100,
    opacity:0,
    rotation: -10,
    duration:1,
    ease: 'Expo.easeOut',
    transformOrigin: 'top center',
    skewX: -10,
})
tl3.from('.temp_display3', {
    x:100,
    y:100,
    opacity:0,
    rotation: -10,
    duration:1,
    ease: 'Expo.easeOut',
    transformOrigin: 'top center',
    skewX: -10,
})
tl4.from('.temp_display4', {
    x:100,
    y:100,
    opacity:0,
    rotation: -10,
    duration:1,
    ease: 'Expo.easeOut',
    transformOrigin: 'top center',
    skewX: -10,
})



// the tags animation
tl.from( tag1 ,{
    x: 50,
    stagger: 0.2,
    opacity: 0,
})
tlt.from( tag2 ,{
    x: 50,
    stagger: 0.2,
    opacity: 0,
})
tlk.from( tag3 ,{
    x: 50,
    stagger: 0.2,
    opacity: 0,
})
tlj.from( tag4 ,{
    x: 50,
    stagger: 0.2,
    opacity: 0,
})


